import React, { useEffect, useState, useCallback } from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import BigNumber from 'bignumber.js'

// components
import Loading from '../../components/Loader/Loading'
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import NoArtworks from '../../components/nftInfo/NoArtworks'
import Artworks from '../Poker/components/Artworks'
import { ButtonLight } from '../../components/Button'
import StakeRow from '../../components/Gamification/StakeGameBox'

import { NFTTYPE } from '../../constants/bakery/nft'

// hooks
import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'
import useUserStakes from '../../hooks/nft/useUserStakes'
import { usePrice } from '../../hooks/usePrice'
import {
  getErc721Balance,
  getNftHelperContract,
  getSoccerPokerGameBoxAddress,
  getBalanceSoccerPokerGameBoxs,
  getSoccerPokerGameBoxMasterContract,
  getSoccerPokerGameBoxInfo,
  getWethContract,
  getPetBnbBlpContract,
  getPetContract,
  getAliceBnbBlpContract,
  getAliceContract,
  getTlmBnbBlpContract,
  getTlmContract,
  commonStakeERC721EarnERC20PoolInfoMap
} from '../../sushi/utils'
import useYam from '../../hooks/bakery/useYam'
import { PokercardProps } from '../../constants/pokercard'
import useInterval from '../../hooks/useInterval'
import useAllowanceAll from '../../hooks/nft/useAllowanceAll'

const UpToButtonLight = styled(ButtonLight)`
  margin-top: 160px;
  padding: 0px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 80px;
  `}
`
const ArtworksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  width: 1220px;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 912px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 608px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
    width: 100%;
  `}
`

export default function MyArtworks () {
  // 钱包信息
  const { account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()

  // 初始化加载动画
  const [loadingFlag, setLoadingFlag] = useState(false)

  // 获取sushi
  const sushi = useYam()
  const pokerBlindBoxAddress: any = getSoccerPokerGameBoxAddress(sushi)

  const tlmBnbPrice = usePrice(getTlmBnbBlpContract(sushi), getTlmContract(sushi), getWethContract(sushi))
  const aliceBnbPrice = usePrice(getAliceBnbBlpContract(sushi), getAliceContract(sushi), getWethContract(sushi))
  const petBnbPrice = usePrice(getPetBnbBlpContract(sushi), getPetContract(sushi), getWethContract(sushi))
  const [bnbAmount, setBnbAmount] = useState(0)
  useEffect(() => {
    let num = (tlmBnbPrice ? tlmBnbPrice.toNumber() : 0) * 1500 + (aliceBnbPrice ? aliceBnbPrice.toNumber() : 0) * 20 + (petBnbPrice ? petBnbPrice.toNumber() : 0) * 20
    setBnbAmount(num)
  }, [tlmBnbPrice, aliceBnbPrice, petBnbPrice])

    // 获取盲盒
  const fetchNftId = useCallback(async (isLoading?: boolean) => {
    // 加载动画
    if(isLoading){
      setLoadingFlag(true)
    }
    let balanceArr: any = []
    const nftHelper = getNftHelperContract(sushi)
    balanceArr = await getErc721Balance(nftHelper, pokerBlindBoxAddress, account)
    const boxs: any[] = balanceArr.map((d: PokercardProps) => {
      return getSoccerPokerGameBoxInfo(d)
    })
    return boxs
  }, [account, sushi, pokerBlindBoxAddress])

  // 获取余额中的gameBox
  const fetchBalancePokerCards = useCallback(async (isLoading?: boolean) => {
    // 加载动画
    if(isLoading){
      setLoadingFlag(isLoading)
    }
    let cardArr: any = []
    cardArr = await getBalanceSoccerPokerGameBoxs(sushi, account)
    const cards: any[] = await Promise.all(cardArr.map(async (d: any) => {
      return await d
    }))
    return cards
  }, [account, sushi])

  // 获取抵押中的gameBox
  let pokerCardMasterContract: any = getSoccerPokerGameBoxMasterContract(sushi)
  const getStakes = useUserStakes(NFTTYPE.GAMEBOX)
  let allStakedAry: any[] = []
  const [allStaked, setAllStaked] = useState(allStakedAry)
  const fetchAllStakingPokerCard = useCallback(async (isLoading?: boolean) => {
    // 加载动画
    if(isLoading){
      setLoadingFlag(isLoading)
    }
    const cardArr: any[] = await getStakes()
    const stakingPokerCards: any[] = cardArr.map((d: any) => {
      return getSoccerPokerGameBoxInfo(d)
    })
    setAllStaked(stakingPokerCards)
    return stakingPokerCards
  }, [setAllStaked, getStakes])

  // 拼接所有nft
  const [stakingPower, setStakingPower] = useState(0)
  const [artworks, setArtworks] = useState<any[]>([])
  const fetchArtworks = useCallback(async (isLoading?: boolean) => {
    
    // 加载动画
    if(isLoading){
      setLoadingFlag(true)
    }
    // 获取池子信息
    const poolInfo = await commonStakeERC721EarnERC20PoolInfoMap(pokerCardMasterContract, pokerBlindBoxAddress)
    setStakingPower(new BigNumber(poolInfo['totalStakingPower']).div(new BigNumber(10).pow(18)).toNumber())
    // 获取盲盒
    const blindBoxs = await fetchNftId(isLoading)
    // 获取余额中的gameBox
    const pokerCards = await fetchBalancePokerCards(isLoading)
    // 获取抵押中的gameBox
    const allStakingPokerCards = await fetchAllStakingPokerCard(isLoading)

    // Deduplication
    const asksSet = new Set()
    blindBoxs.forEach((d: any) => {
      asksSet.add(d.tokenId.toString())
    })

    const allNfts = [
      ...blindBoxs,
      ...allStakingPokerCards,
      ...(pokerCards.filter((d: any) => {
        return !asksSet.has(d.tokenId.toString())
      }))
    ]

    // 拼接nft
    if (!blindBoxs.length && !allNfts.length) {
      setArtworks([])
      setLoadingFlag(false)
    } else {
      setArtworks(allNfts)
      setLoadingFlag(false)
    }
  }, [fetchNftId, fetchBalancePokerCards, fetchAllStakingPokerCard, pokerBlindBoxAddress, pokerCardMasterContract])

  // 初始化渲染
  useEffect(() => {
    if (account) {
      fetchArtworks(true)
    }
  }, [account, fetchArtworks])

  useInterval(fetchArtworks, account ? 10000 : null)

  const allowanceStake = useAllowanceAll({type: NFTTYPE.GAMEBOX})

  return (
    <>
      <Loading open={loadingFlag} />
      {
        !account ? (
          <UpToButtonLight width={'180px'} height={40} onClick={toggleWalletModal}>
            Connect Wallet
          </UpToButtonLight>
          ) : <>
            <BodyHead>
              <BodyTitle fontSize={32} fontWeight={700}>My BSC Game Box NFTs</BodyTitle>
              <Text fontSize={16}>
                Wish you could get your best BSC Game Box NFTs {' '}
                <span role="img" aria-label="smile">
                  😋
                </span>
              </Text>
            </BodyHead>
            <StakeRow stakedBalanceArr={allStaked} lpTokenAddress={pokerBlindBoxAddress} masterContract={pokerCardMasterContract} type={NFTTYPE.GAMEBOX} />
            {
              loadingFlag
                ? null
                : !account || artworks.length === 0 ? (
                  <NoArtworks type={NFTTYPE.GAMEBOX} ownBtn={true} status={1} />
                ) : (
                  <>
                    <ArtworksList>
                      {
                        artworks.map((d) => {
                          return (
                            <Artworks key={d.tokenId} artwork={d} type={NFTTYPE.GAMEBOX} isMyArtwork={true} allowanceStake={allowanceStake} bnbAmount={new BigNumber(20000 * 365 * 100).times(tlmBnbPrice ? tlmBnbPrice.toNumber() : 1).div(stakingPower * bnbAmount).toNumber()} />
                          )
                        })
                      }
                    </ArtworksList>
                  </>
                )
            }
          </>
      }
    </>
  )
}
